export default "__VITE_ASSET__CovrNnV$__"